import QrFavorSection from '@/features/qr/components/QrFavorSection'
import QrImageSection from '@/features/qr/components/QrImageSection'
import { useUser } from '@/shared/hooks'

const QrPage = () => {
  useUser().qr.request().then()

  return (
    <>
      <QrImageSection />
      <QrFavorSection />
    </>
  )
}

export default QrPage
